module.exports = __webpack_public_path__ + "media/images/athletes/547-0c13ca54240fdb8507f2ad877058f738.png";